import { Chip } from "@mui/material";
import { Rental } from "src/models";
import { Constants } from "src/constants";

// one entry per lifecycle stage — the label staff sees and the chip color:
// grey = not started or finished, blue = waiting on someone, lime = staff
// action needed, green = confirmed, red only when something is wrong
const RENTAL_STATUS_DISPLAY: Record<number, { label: string; color: "default" | "primary" | "info" | "success" | "error" }> = {
  [Constants.RENTAL_STATUS_DRAFT]: { label: "Draft", color: "default" },
  [Constants.RENTAL_STATUS_INSURANCE_SENT]: { label: "Insurance Sent", color: "info" },
  [Constants.RENTAL_STATUS_INSURANCE_SUBMITTED]: { label: "Insurance Review Needed", color: "primary" },
  [Constants.RENTAL_STATUS_INSURANCE_CONFIRMED]: { label: "Insurance Confirmed", color: "success" },
  [Constants.RENTAL_STATUS_AGREEMENT_SENT]: { label: "Agreement Sent", color: "info" },
  [Constants.RENTAL_STATUS_AGREEMENT_SUBMITTED]: { label: "Agreement Review Needed", color: "primary" },
  [Constants.RENTAL_STATUS_AGREEMENT_CONFIRMED]: { label: "Ready for Outbound", color: "success" },
  [Constants.RENTAL_STATUS_ACTIVE]: { label: "Active", color: "success" },
  [Constants.RENTAL_STATUS_RETURNED]: { label: "Returned", color: "info" },
  [Constants.RENTAL_STATUS_COMPLETED]: { label: "Completed", color: "default" },
};

export function rentalStatusLabel(rental: Rental) {
  if (!rental.active && rental.rentalStatus < Constants.RENTAL_STATUS_ACTIVE) {
    return "Cancelled";
  }
  return RENTAL_STATUS_DISPLAY[rental.rentalStatus]?.label || "Unknown";
}

export function RentalStatusStageChip({ rental }: { rental: Rental }) {
  if (!rental.active && rental.rentalStatus < Constants.RENTAL_STATUS_ACTIVE) {
    return <Chip size="small" color="error" label="Cancelled" />;
  }
  const display = RENTAL_STATUS_DISPLAY[rental.rentalStatus];
  return <Chip size="small" color={display?.color || "default"} label={display?.label || "Unknown"} />;
}

// an ongoing rental blocks starting another one for the same unit
export function isOngoingRental(rental: Rental) {
  return rental.active && rental.rentalStatus < Constants.RENTAL_STATUS_COMPLETED;
}
